import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { lcActions } from '../../../store/layoutConfiguration';

/**
 * The header full screen toggle.
 */
const FullScreenToggle = ({ children }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        document.onfullscreenchange = () =>
            dispatch(lcActions.updateFullScreenStatus(document[getBrowserFullscreenElementProp()] != null))
        return () => {
            document.onfullscreenchange = null;
        };
    });

    function getBrowserFullscreenElementProp() {
        const doc = document;

        if (typeof doc.fullscreenElement !== 'undefined') {
            return 'fullscreenElement';
        }
        if (typeof doc.mozFullScreenElement !== 'undefined') {
            return 'mozFullScreenElement';
        }
        if (typeof doc.msFullscreenElement !== 'undefined') {
            return 'msFullscreenElement';
        }
        if (typeof doc.webkitFullscreenElement !== 'undefined') {
            return 'webkitFullscreenElement';
        }
        throw new Error('fullscreenElement is not supported by this browser');
    }

    /* View in fullscreen */
    function openFullscreen() {
        const elem = document.documentElement;

        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
            /* Firefox */
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
            /* Chrome, Safari and Opera */
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
            /* IE/Edge */
            elem.msRequestFullscreen();
        }
    }

    /* Close fullscreen */
    function closeFullscreen() {
        const doc = document;

        if (doc.exitFullscreen) {
            doc.exitFullscreen();
        } else if (doc.mozCancelFullScreen) {
            /* Firefox */
            doc.mozCancelFullScreen();
        } else if (doc.webkitExitFullscreen) {
            /* Chrome, Safari and Opera */
            doc.webkitExitFullscreen();
        } else if (doc.msExitFullscreen) {
            /* IE/Edge */
            doc.msExitFullscreen();
        }
    }

    function toggleFullScreen() {
        const doc = document;
        if (doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement) {
            closeFullscreen();
        } else {
            openFullscreen();
        }
    }

    return (
        <div onClick={toggleFullScreen}>
            {children}
        </div>
    );
}

export default FullScreenToggle;
